export const getBeneficiaryProperty = (ben: any) => {
  if (!ben?.paymentType) return null;

  const paymentMapping: Record<number, string | undefined> = {
    1: ben.swiftPayment?.ibanAccount.ibanAccount,
    2: ben.ibanPayment?.bic,
    3: ben.localAccountPayment?.accountNumber,
    4: ben.swiftUnknown?.accountNumber,
  };

  return paymentMapping[ben.paymentType] || null;
};
